module.exports = __webpack_public_path__ + "static/media/undraw_personal_text_vkd8.b805285b.svg";